const services = [
  { href: "/services/mvp-development", label: "MVP Development" },
  { href: "/services/ai-workflow-automation", label: "AI Workflow Automation" },
  { href: "/services/dedicated-developers", label: "Dedicated Developers" },
]

const company = [
  { href: "/about", label: "About" },
  { href: "/careers", label: "Careers" },
  { href: "/#contact", label: "Contact" },
]

export function Footer() {
  return (
    <footer className="w-full bg-slate-900 text-white py-12 md:py-16">
      <div className="container px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          <div className="md:col-span-1 space-y-4">
            <a href="/" className="flex items-center gap-2">
              <img src="/logo.png" alt="Optimal Dev Labs" className="h-8 w-8" />
              <span className="font-bold text-lg">Optimal Dev Labs</span>
            </a>
            <p className="text-sm text-slate-400">Build faster. Automate more. Hire less.</p>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-400">Services</h3>
            <nav className="flex flex-col gap-2">
              {services.map((link) => (
                <a key={link.href} href={link.href} className="text-sm text-slate-300 hover:text-white transition-colors">
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-400">Company</h3>
            <nav className="flex flex-col gap-2">
              {company.map((link) => (
                <a key={link.href} href={link.href} className="text-sm text-slate-300 hover:text-white transition-colors">
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-400">Ready to start?</h3>
            <p className="text-sm text-slate-300">Book a discovery call and let&apos;s talk about your project.</p>
            <a
              href="/#contact"
              className="inline-block px-4 py-2 text-sm font-medium text-white rounded-md hover:opacity-90 transition-opacity"
              style={{ backgroundColor: "#ed2132" }}
            >
              Book a Call
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-400">© 2026 Optimal Dev Labs. All rights reserved.</p>
          <nav className="flex gap-6">
            <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors">Terms of Service</a>
          </nav>
        </div>
      </div>
    </footer>
  )
}
